export default __webpack_public_path__ + "static/media/Ronak Sahuja.91b0bb40.jpg";